@if (isDesktopView) {
  <div class="filters-desktop">
    <div class="filters-row">
      <div class="filter-field">
        <label for="from-date-desktop">
          {{ 'SETTINGS_SMS.REPORT.FILTERS.FROM_DATE' | translate }}
        </label>
        <p-datepicker
          inputId="from-date-desktop"
          [ngModel]="localFromDate()"
          (ngModelChange)="onFromDateChange($event)"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          [minDate]="minDate"
          [maxDate]="localToDate() || maxDate"
          [placeholder]="'SETTINGS_SMS.REPORT.FILTERS.SELECT_START_DATE' | translate"
          styleClass="filter-input" />
      </div>

      <div class="filter-field">
        <label for="to-date-desktop">{{ 'SETTINGS_SMS.REPORT.FILTERS.TO_DATE' | translate }}</label>
        <p-datepicker
          inputId="to-date-desktop"
          [ngModel]="localToDate()"
          (ngModelChange)="onToDateChange($event)"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          [minDate]="localFromDate() || minDate"
          [maxDate]="maxDate"
          [placeholder]="'SETTINGS_SMS.REPORT.FILTERS.SELECT_END_DATE' | translate"
          styleClass="filter-input" />
      </div>

      <div class="filter-field">
        <label for="status-desktop">
          {{ 'SETTINGS_SMS.REPORT.FILTERS.STATUS' | translate }}
        </label>
        <p-select
          inputId="status-desktop"
          [ngModel]="localStatus()"
          (ngModelChange)="onStatusChange($event)"
          [options]="statusOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'SETTINGS_SMS.REPORT.FILTERS.SELECT_STATUS' | translate"
          [showClear]="true"
          styleClass="filter-input" />
      </div>

      <p-button
        label="{{ 'GENERAL.APPLY' | translate }}"
        severity="primary"
        [disabled]="isLoading()"
        (onClick)="applyFilters()" />
      <p-button
        label="{{ 'GENERAL.CLEAR' | translate }}"
        severity="secondary"
        [disabled]="!hasActiveFilters() || isLoading()"
        (onClick)="clearFilters()" />
      <p-button
        icon="pi pi-refresh"
        severity="secondary"
        [outlined]="true"
        [loading]="isLoading()"
        [disabled]="isLoading()"
        (onClick)="refresh.emit()"
        [pTooltip]="'GENERAL.REFRESH' | translate"
        tooltipPosition="top" />
    </div>
  </div>
}
@if (isTabletView) {
  <div class="filters-tablet">
    <p-button
      label="{{ 'SETTINGS_SMS.REPORT.FILTERS.FILTERS' | translate }}"
      icon="pi pi-filter"
      [severity]="hasActiveFilters() ? 'primary' : 'secondary'"
      badgeClass="filter-badge"
      (onClick)="toggleFilterPopover($event)" />

    @if (hasActiveFilters()) {
      <p-button
        label="{{ 'SETTINGS_SMS.REPORT.FILTERS.CLEAR_FILTERS' | translate }}"
        icon="pi pi-filter-slash"
        severity="secondary"
        (onClick)="clearFilters()" />
    }
    <p-button
      icon="pi pi-refresh"
      severity="secondary"
      [outlined]="true"
      [loading]="isLoading()"
      [disabled]="isLoading()"
      (onClick)="refresh.emit()"
      [pTooltip]="'GENERAL.REFRESH' | translate"
      tooltipPosition="top" />
  </div>

  <p-popover #filterPopover styleClass="sms-report-filter-popover" [focusOnShow]="false">
    <div class="filter-content">
      <div class="filter-section">
        <div class="filter-field">
          <label for="from-date-tablet">
            {{ 'SETTINGS_SMS.REPORT.FILTERS.FROM_DATE' | translate }}
          </label>
          <p-datepicker
            inputId="from-date-tablet"
            [ngModel]="localFromDate()"
            (ngModelChange)="onFromDateChange($event)"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [minDate]="minDate"
            [maxDate]="localToDate() || maxDate"
            [placeholder]="'SETTINGS_SMS.REPORT.FILTERS.SELECT_START_DATE' | translate"
            styleClass="filter-input" />
        </div>

        <div class="filter-field">
          <label for="to-date-tablet">
            {{ 'SETTINGS_SMS.REPORT.FILTERS.TO_DATE' | translate }}
          </label>
          <p-datepicker
            inputId="to-date-tablet"
            [ngModel]="localToDate()"
            (ngModelChange)="onToDateChange($event)"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [minDate]="localFromDate() || minDate"
            [maxDate]="maxDate"
            [placeholder]="'SETTINGS_SMS.REPORT.FILTERS.SELECT_END_DATE' | translate"
            styleClass="filter-input" />
        </div>
      </div>

      <div class="filter-section">
        <div class="filter-field">
          <label for="status-tablet">
            {{ 'SETTINGS_SMS.REPORT.FILTERS.STATUS' | translate }}
          </label>
          <p-select
            inputId="status-tablet"
            [ngModel]="localStatus()"
            (ngModelChange)="onStatusChange($event)"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'SETTINGS_SMS.REPORT.FILTERS.SELECT_STATUS' | translate"
            [showClear]="true"
            styleClass="filter-input" />
        </div>
      </div>

      <div class="filter-actions">
        <p-button
          label="{{ 'GENERAL.APPLY' | translate }}"
          severity="primary"
          styleClass="w-full"
          (onClick)="applyFilters()" />
        <p-button
          label="{{ 'GENERAL.CLEAR' | translate }}"
          severity="secondary"
          styleClass="w-full"
          (onClick)="clearFilters()" />
      </div>
    </div>
  </p-popover>
}
